/** The first wall action gets one introduction; its matching tool awards stay
 * in the collection. Later tool discoveries keep their own celebrations. */
export function achievementNoticeIds(ids:readonly string[]):string[]{
 if(!ids.includes('first-spray'))return [...ids];
 return ids.filter(id=>id!=='first-draw'&&id!=='first-stamp'&&id!=='first-image'&&id!=='cut-above'&&!id.startsWith('tool-'));
}
